import React, { useState } from "react";
import { Pagination, PaginationItem, Button } from "@mui/material";
import arrowleft from "../../../src/assests/images/arrow_left.svg";


interface PaginationProps {
  page: number;
  limit: number;
  totalPages: number
  setPage: (page: number) => void
}

const PaginationComponent: React.FC<PaginationProps> = ({ page, limit, setPage, totalPages }) => {





  return (
    <div>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(event, value) => setPage(value)}
        renderItem={(item) => (
          <PaginationItem
            components={{
              previous: () => (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "transparent",
                    border: "1px solid rgba(208, 213, 221, 1)",
                    borderRadius: "8px",
                    boxShadow: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#000",
                    textTransform: "capitalize",
                    opacity: item.disabled ? "0.5" : "1",
                    margin: "0"
                  }}
                >
                  <img
                    style={{ marginRight: "12px" }}
                    src={arrowleft}
                    alt="Previous"
                  />
                  Previous
                </Button>
              ),
              next: () => (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "transparent",
                    border: "1px solid rgba(208, 213, 221, 1)",
                    borderRadius: "8px",
                    boxShadow: "none",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#000",
                    textTransform: "capitalize",
                    opacity: item.disabled ? "0.5" : "1",
                  }}
                >
                  Next
                  <img
                    style={{
                      marginLeft: "12px",
                      transform: "rotate(180deg)",
                    }}
                    src={arrowleft}
                    alt="Next"
                  />
                </Button>
              ),
            }}
            {...item}
          />
        )}

        sx={{
          "li:first-of-type": { position: "absolute", left: "10px" },
          "li:last-of-type": { position: "absolute", right: "10px" },
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px 0",
          ".Mui-selected": {
            backgroundColor: "rgba(245, 251, 255, 1) !important",
            borderRadius: "8px",
            color: "rgba(87, 163, 253, 1)",
            fontWeight: "500",
            ".MuiPaginationItem-text": {
              fontSize: "14px !important",
              fontWeight: "500",
            },
          },
        }}
      />

    </div>
  );
}
export default PaginationComponent;